import React,{useState} from "react";
import { useTranslate } from 'react-redux-multilingual'
import { useForm } from "react-hook-form";
import NumericKeypad from './NumericKeypad'

const AddArticlePriceForm = (props) =>{
    const t = useTranslate()
    const [inputValue,setInputValue]=useState('')
    const [validButton,setValidButton]=useState(false)
    const { register, formState: { errors }, handleSubmit, setValue } = useForm();

    let digit = (props.authParam.company.advanceparams.hasOwnProperty('ventilation_espece') && props.authParam.company.advanceparams.ventilation_espece.piece.find(piece=> +piece < 1)) ? 2 : 0;
    let allowDecimal = digit!=0

    const handleChange = (e) =>{
        if(digit==0){
            setInputValue(e.target.value.replace(/\D/g,''))
        }else{
            setInputValue(e.target.value.replace(/[^0-9,]/g, ''))
        }
    }

    const handleKeypadChange = (newValue) =>{
        setInputValue(newValue)
        setValue('amount',newValue,{shouldValidate:true})
    }

    const submit = (data) => {
        setValidButton(true)
        let obj={
            article_modif_manual_type:'modif',
            article_modif_manual_value:(''+data.amount).replace(',','.')
        }
        props.onValidate(obj)
    }

    const { ref:amountRegisterRef, ...amountRegisterRest } = register('amount',{required: true, onChange :(e) => handleChange(e)});

    return(
        <form onSubmit={handleSubmit(submit)}>
            <div className="input-group mb-3">
                <input
                    autoComplete='off'
                    className='form-control mb-1'
                    placeholder={t('newPrice')}
                    value={inputValue}
                    type="text"
                    aria-describedby="basic-addon1"
                    ref={(el)=>{ amountRegisterRef(el); if(props.amountInputRef) props.amountInputRef.current=el; }}
                    {...amountRegisterRest}
                />
            </div>
            {errors.amount?.type === 'required' && (
                <div className="text-danger mt-1 ml-2">
                    {t('fieldRequired')}
                </div>
            )}

            <NumericKeypad value={inputValue} onChange={handleKeypadChange} allowDecimal={allowDecimal} />

            <button disabled={validButton} className="btn btn-primary mt-3">
                {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
            </button>
        </form>
    )
}

export default AddArticlePriceForm;
